import { render, staticRenderFns } from "./KoneksiEmailIcon.vue?vue&type=template&id=2a09beee"
import script from "./KoneksiEmailIcon.vue?vue&type=script&lang=js"
export * from "./KoneksiEmailIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports